function request<T>(onMessage: T, onError: T) {
	return {
		url: `/websocket/connect`,
		onMessage,
		contentType: 'application/json',
		transport: 'websocket',
		/*
		 * Handling reconnections manually to avoid dropped connections
		 */
		reconnect: false,
		timeout: 30_000, // 30 seconds timeout
		/**
		 * Handling client timeout as an error to update the status accordingly
		 */
		onError,
		onClientTimeout: onError
	};
}

export default request;
